const DayOfWeek = ({dayOfWeek})=>{
    return (
        <div className={"text-center"}>
            {dayOfWeek}
        </div>
    )
}

export default DayOfWeek